import React, { createContext } from 'react';
import { AccountResponse } from '../structures/response/AccountResponse';

interface AccountContextValue {
  accountResponse: AccountResponse | null;
  setAccountResponse: React.Dispatch<
    React.SetStateAction<AccountResponse | null>
  >;
}

const AccountContext = createContext<AccountContextValue>({
  accountResponse: null,
  setAccountResponse: () => null,
});

export default AccountContext;
